import { gql } from '@apollo/client';

export const STOCK_CAR_SEARCH = gql`
  query StockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      resultNumber
      results {
        cars {
          stockCar {
            id
            vin
            weblink
            titleText
            model {
              name
              salesModelyear
              id {
                code
              }
            }
            modelInfo {
              genericModel {
                code
                text
              }
              modelyear
            }
            code {
              id
            }
            dealer {
              id
              name
              region
            }
            salesInfo {
              availableFromDateInfo {
                value
                type
              }
              offerDateInfo {
                type
                value
              }
              orderStatusText
              physicalOrderStatus
              saleOrderTypeText
            }
            mileage {
              value {
                number
                formatted
              }
              unitText
            }
            qualityLabel {
              label
            }
            subtitleText
            cartypeText
            commissionNumber
            dynamicAttributes {
              id
              value
            }
            carline {
              id
              name
            }
            gearText
            metaData {
              statImport
            }
            mileage {
              unitText
              value {
                formatted
                number
              }
            }
            carPrices {
              label
              price {
                value
                valueAsText
                formattedValue
              }
              type
            }
          }
        }
      }
    }
  }
`;

export const STOCK_CAR_BY_ID = gql`
  query StockCar($stockCarIdentifier: StockCarIdentifierInput!) {
    stockCar(stockCarIdentifier: $stockCarIdentifier) {
      id
      vin
      weblink
      titleText
      model {
        name
        salesModelyear
        id {
          code
        }
      }
      modelInfo {
        genericModel {
          code
          text
        }
        modelyear
      }
      code {
        id
      }
      dealer {
        id
        name
        region
      }
      salesInfo {
        availableFromDateInfo {
          value
          type
        }
        isBuyOnline
        offerDateInfo {
          type
          value
        }
        orderStatusText
        physicalOrderStatus
        saleOrderTypeText
      }
      engineInfo {
        maxPowerKW {
          unitText
          value {
            number
            formatted
          }
        }
        fuel {
          code
          text
        }
      }
      mileage {
        value {
          number
          formatted
        }
        unitText
      }
      qualityLabel {
        label
      }
      subtitleText
      cartypeText
      commissionNumber
      colorInfo {
        exteriorColor {
          colorInfo {
            text
          }
          baseColorInfo {
            code
            text
          }
        }
        interiorColor {
          colorInfo {
            text
          }
          baseColorInfo {
            code
            text
          }
        }
      }
      driveText
      dynamicAttributes {
        id
        value
      }
      carline {
        id
        name
      }
      gearText
      metaData {
        statImport
      }
      mileage {
        unitText
        value {
          formatted
          number
        }
      }
      carPrices {
        disclaimers {
          id
          legalEntityKey
          text
        }
        label
        price {
          value
          valueAsText
          formattedValue
        }
        type
      }
    }
  }
`;
